import styled from "styled-components";

export const Wrapper = styled.div`
    
`
export const Content = styled.div`
    
    border-radius: 10px;
    box-shadow: ${props => (props.switchOn ? '0 5px 9px white inset':'0 5px 9px white inset, 0 5px 9px grey' )};
    padding: 15px;
    background: ${props => (props.switchOn ? props.colorone:props.colortwo )};
    transform: ${props => (props.switchOn ? 'translateY(5px) translateX(4px)': null)};
    color: white;
    text-align: center;
    align-items: center;
    
    width: ${props=> (props.list?'50px':'')}

`